<template>
  <div>
    <Head title="Create Brand" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/brands">Brands</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Brand name" />
            <text-input v-model="form.domain_frontend" :error="form.errors.domain_frontend" class="pb-8 pr-6 w-full lg:w-1/2" label="Frontend domain" />
            <text-input v-model="form.locale" :error="form.errors.locale" class="pb-8 pr-6 w-full lg:w-1/2" label="Default locale" />
            <text-input v-model="form.domain_backend" :error="form.errors.domain_backend" class="pb-8 pr-6 w-full lg:w-1/2" label="Backend domain" />
            <text-input v-model="form.timezone" :error="form.errors.timezone" class="pb-8 pr-6 w-full lg:w-1/2" label="Timezone" />
            <multiple-select-input v-model="form.locales" :error="form.errors.timezone"  class="pb-8 pr-6 w-full lg:w-1/2" label="Available locales">
                <option value="en">EN</option>
                <option value="de">DE</option>
            </multiple-select-input>
            <textarea-input v-model="form.meta" :rows="20" :error="form.errors.meta"  class="pb-8 pr-6 w-full lg:w-1/2" label="Meta data"></textarea-input>
            <textarea-input v-model="form.options" :rows="20" :error="form.errors.options"  class="pb-8 pr-6 w-full lg:w-1/2" label="Options data"></textarea-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Brand</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import TextareaInput from "@/Shared/TextareaInput";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
      MultipleSelectInput,
      TextareaInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
            name: '',
            domain_frontend: '',
            domain_backend: '',
            timezone: '',
            locale: '',
            locales: [],
            meta: '{}',
            options: '{}',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/brands')
    },
  },
}
</script>
